import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ToastrService } from "ngx-toastr";
import {  Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GlobalComponent } from "src/app/global/global.component";
import { NgxExtendedPdfViewerService } from "ngx-extended-pdf-viewer";
import { v4 as uuidv4 } from "uuid";
import {
  DEEventEmitterBo,
  DynamicClientFormSaveBO,
  GenerateDynamicClientEmployeeFormBO,
} from "../client-employee-dynamicform.model";
import { CommonApiService } from "src/app/commonapiservice";
import { lovDropdown } from "../../lov/lov.model";
import { log } from "console";

@Component({
  selector: "app-client-employee-dynamicform-edit",
  templateUrl: "./client-employee-dynamicform-edit.component.html",
  styleUrls: ["./client-employee-dynamicform-edit.component.scss"],
})
export class ClientEmployeeDynamicformEditComponent implements OnInit {
  isSaveorUpdateBoolean:boolean=false;
  @ViewChild('modalElement', { static: false }) modalElement: ElementRef;
  dynamicFormTemplateType: any = [];
  @Input() EditCEInputProperty: DEEventEmitterBo = new DEEventEmitterBo();
  @Output() EditOutputCE = new EventEmitter<DEEventEmitterBo>();
  saveBo: DynamicClientFormSaveBO = new DynamicClientFormSaveBO();
  private onDestroy$: Subject<void> = new Subject<void>();
  FileURl: any;
  generateDynamicFormBO: GenerateDynamicClientEmployeeFormBO =
    new GenerateDynamicClientEmployeeFormBO();
  dynamicFormTemplateId: string = "";
  entityTypeCode: string;
  name: string;
  Output: any = "";
  templateName: string = "";
  selectrole: any;
  GroupFilter:any;
  GroupNameList:lovDropdown;
  logintype:string=null;
  constructor(
    private ngxService: NgxExtendedPdfViewerService,
    public global: GlobalComponent,
    public CommonAPI: CommonApiService,
    public toasterService: ToastrService
  ) {
  }
  ngOnInit(): void {
    this.logintype = localStorage.getItem("CFSS_checkType");
    this.GroupFilter=null;
    this.generateDynamicFormBO.templateId = null;
    this.selectrole = "agency";
    this.getDynamicFormTemplateDropDown('');

    // document.getElementById('openTemplateModal').click()
    // if (this.modalElement) {
    //   // Your logic to manipulate the modal element
     
    // } else {
    //   console.error('Modal element is not available.');
    // }
  
    this.GroupDocumentDropdown();
  }

  // ngAfterViewInit(): void {
  //   if (this.modalElement) {
  
  //     // this.initializeModal();
  //     document.getElementById('openTemplateModal').click()
  //   } else {
  //     console.error('Modal element is not available.');
  //   }
  // }


  //................................................clearModal....................................
  saveEditedPdf() {
    if (this.EditCEInputProperty.details.Dynamictype == "Client") {
      this.saveDynamicClientForm();
    } else if (this.EditCEInputProperty.details.Dynamictype == "Employee") {
      this.saveDynamicEmployeeForm();
    }
  }
  //................................................saveDynamicClientForm...........................................
  async saveDynamicClientForm() {
    this.isSaveorUpdateBoolean=true;
    const blob = await this.ngxService.getCurrentDocumentAsBlob();
    let fileName: any;
      fileName = "Dynamicclientform" + uuidv4().replace(/-/g, "") + ".pdf";
    const file = new File([blob], fileName);
    let Formdata = new FormData();
    Formdata.append("clientId", this.EditCEInputProperty.details.Id.toString());
    Formdata.append(
      "dynamicFormTemplateId",
      this.generateDynamicFormBO.templateId
    );
    Formdata.append("file", file);
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_DynamicForms/saveDynamicClientForm";
      }
      else{

         url = "api/DynamicClientForm/saveDynamicClientForm";
      }
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(Formdata,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterService.success("Form saved successfully");
          document.getElementById("openTemplateModal").click();
          document.getElementById("openPdfModal").click();
          this.closeEdit();
        },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
   //................................................saveDynamicClientForm...........................................
  closeEdit() { 
    this.EditCEInputProperty.isCreate=false;
    this.EditCEInputProperty.isClose=false;
    this.EditOutputCE.emit(this.EditCEInputProperty)
  }
  //................................................saveDynamicClientForm...........................................
  async saveDynamicEmployeeForm() {
  this.isSaveorUpdateBoolean=true;
    const blob = await this.ngxService.getCurrentDocumentAsBlob();
    const fileName = "DynamicEmployeeform" + uuidv4().replace(/-/g, "") + ".pdf";
    const file = new File([blob], fileName);
    let Formdata = new FormData();
    Formdata.append("employeeId", this.EditCEInputProperty.details.Id.toString());
    Formdata.append(
      "dynamicFormTemplateId",
      this.generateDynamicFormBO.templateId
    );
    Formdata.append("file", file);
    let url=""
    if(this.global.OnboardType=="EMPLOYEE")
    {
      url = "api/Employee_DynamicForms/saveDynamicEmployeeForm";
    }
    else{
      url = "api/DynamicEmployeeForms/saveDynamicEmployeeForm";
    }
    
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(Formdata,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterService.success("Form saved successfully");
          // document.getElementById("openTemplateModal").click();
           document.getElementById("openTemplateModal").click();
           document.getElementById("openPdfModal").click();
          this.closeEdit();
        },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  generateDynamicForms() {
    this.isSaveorUpdateBoolean=true;
    if (this.EditCEInputProperty.details.Dynamictype == "Client") {
      this.generateDynamicClientForm();
    } else if (this.EditCEInputProperty.details.Dynamictype == "Employee") {
      this.generateDynamicEmployeeForm();
    }
  }
  //................................................generateDynamicClientForm...........................................
  generateDynamicClientForm() {
    let payload = {
      clientId: this.EditCEInputProperty.details.Id,
      templateId: this.generateDynamicFormBO.templateId,
    };
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_DynamicForms/generateDynamicClientForm";
      }
      else{

         url = "api/DynamicClientForm/generateDynamicClientForm";
      }
   
    this.CommonAPI.saveorUpdateFunctionResponseTypeAsBlob(payload,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.isSaveorUpdateBoolean=false;
          let file = new Blob([data], { type: "application/pdf" });
          this.FileURl = file;
          document.getElementById("openPdfModal").click();
        },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }
  //................................................generateDynamicEmployeeForm...........................................
  generateDynamicEmployeeForm() {
    let payload = {
      employeeId: this.EditCEInputProperty.details.Id,
      templateId: this.generateDynamicFormBO.templateId,
    };
    let url=''
    if(this.global.OnboardType=="EMPLOYEE")
    {
      url = "api/Employee_DynamicForms/generateDynamicEmployeeForm";
    }else{
      url = "api/DynamicEmployeeForms/generateDynamicEmployeeForm";
    }
     
    this.CommonAPI.saveorUpdateFunctionResponseTypeAsBlob(payload,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.isSaveorUpdateBoolean=false;
          let file = new Blob([data], { type: "application/pdf" });
          this.FileURl = file;
          document.getElementById("openPdfModal").click();
        },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterService.error(err, "Error"), 8000;
        }
      );
  }

  onRoleChange() {
   
    this.cleardata();
  }
  // ................................................getDynamicFormTemplateDropDown.............................................
  getDynamicFormTemplateDropDown(GroupFilter) {
    this.dynamicFormTemplateType = [];
    this.generateDynamicFormBO.templateId = "";
    let params = new URLSearchParams();
    if (this.EditCEInputProperty.details.Dynamictype == "Client") {
      params.append("entityTypeCode", "CLIENT");
    } else if (this.EditCEInputProperty.details.Dynamictype == "Employee") {
      params.append("entityTypeCode", "EMPLOYEE");
    }
    params.append(
      "AgencyId",
      this.selectrole == "agency" ? this.global.globalAgencyId : ''
    );
   
    let url;
    if(this.logintype =='onboardLogin')
      {
         url = "api/Client_DynamicForms/getDynamicFormTemplateDropDown?";
      }
      else{

         url = "api/DynamicClientForm/getDynamicFormTemplateDropDown?";
      }
    this.CommonAPI.GetFunctionwithResponseTypeJson(params,url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.dynamicFormTemplateType = data;
        },
        (err: any) => {
          this.toasterService.error("error");
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
      );
  }
  selectTemplate(value){
    // if(value==null||value==undefined||value==''){
    //   this.generateDynamicFormBO.templateId=null;
    // }else{
      this.getDynamicFormTemplateDropDown(value)
    //}
  }
  GroupDocumentDropdown() {
    document.getElementById('openTemplateModal').click();
    // let params = new URLSearchParams();
    // if (this.EditCEInputProperty.details.Dynamictype.toUpperCase() == 'CLIENT') 
    //   {      
    //     params.append("Code", "DYNAMICTEMPLATECLIENTGROUP");
    // }
    // else if (this.EditCEInputProperty.details.Dynamictype.toUpperCase() == 'EMPLOYEE') {
    //   params.append("Code", "DYNAMICTEMPLATEEMPLOYEEGROUP");
    // };
    // if(this.selectrole=='agency'){
    //   var url = "api/Lov/getLovType?";
    // }
    // else{
    //   var url="api/Lov/getLovDropDownByCode?";
    // }
    
    // params.append("userId", this.global.userID);
    // this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //   this.GroupNameList = data;
   
      
    // })
  }
  cleardata(){
    this.GroupFilter=null;
    this.generateDynamicFormBO.templateId = null;
  
    
    // this.GroupDocumentDropdown();
    this.selectTemplate('');
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}
